import React, { useCallback, useEffect, useState } from "react";
import { addNotification as notify } from "reapop";
import { connect } from "react-redux";
import AdminNavigation from "../AdminNavigation";
import { TETRulesConfigurationFields } from "./Field";
import TETRulesDraft from "./V2TETRulesDraft";
import TETRulesLive from "./V2TETRulesLive";
import Select from "../../../forms/Select";
import { validateField } from "../../../pages/functions";
import { api_v2 } from "../../NewIndex.api.js";
import "jquery-ui-dist/jquery-ui.min.css";
import "jquery-ui-dist/jquery-ui.min.js";
import AdminConfirmationModal from "../adminConfirmationModal";
import "./Styles.css";
// import "../styles.css";
import { REF_DATA } from "../../../constants.js";
import { getApplicationRegex } from "../../plugins/utils.js";

const TETRulesConfiguration = (props) => {
  const [countryOptions, setCountryOptions] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [languageOptions, setLanguageOptions] = useState([]);
  const [userTypeOptions, setUserTypeOptions] = useState([]);
  const [productOptions, setProductOptions] = useState([]);
  const [showRule, setShowRule] = useState(false);
  const [fields, setFields] = useState(TETRulesConfigurationFields);
  const [showAdminConfirmationModal, setShowAdminConfirmationModal] =
    useState(false);
  const [activeTab, setActiveTab] = useState("liveTETData");

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };

  const validate = useCallback((e, field) => {
    const inputValue = e.target.value.toLowerCase();
    const ref_Data = props.referenceData.find(function (category) {
      return category.type === REF_DATA;
    }).referenceData;
    const regex = getApplicationRegex(ref_Data);

    if (regex.Emoji_Regex !== null && regex.Emoji_Regex.test(inputValue)) {
      // Emoji detected, prevent it from being added
      showNotification(
        "Error!",
        "Special characters are not allowed",
        "error"
      );
      return;
    } else if (regex.Script_Regex !== null && regex.Script_Regex.test(inputValue)) {
      // HTML Tags and Script detected, prevent it from being added
      showNotification(
        "Error!",
        "Submission fails. Input contains prohibited words. Please remove them and try again.",
        "error"
      );
      return;
    } else if (regex.Script_Regex === null || regex.Emoji_Regex === null) {
      showNotification(
        "Error!",
        "Validation configuration is missing. Please contact support.",
        "error"
      );
      return;
    }
    const validateFields = validateField(e, field, fields);
    setFields({ ...validateFields });
  }, []);

  const getCountriesList = useCallback(() => {
    const countryOptions = [];
    api_v2.fetchTETCountries((JsonKeys) => {
      JsonKeys.forEach((countryList) => {
        countryOptions.push({
          value: countryList.country,
          label: countryList.country,
        });
      });
      setCountryList(JsonKeys);
      setCountryOptions(countryOptions);
    });
  }, []);

  const resetState = () => {
    let fieldsValue = fields;
    fieldsValue.country.value = "";
    fieldsValue.product.value = "";
    fieldsValue.userType.value = "";
    fieldsValue.language.value = "";
    setShowRule(false);
    setFields({ ...fieldsValue });
    setShowAdminConfirmationModal(false);
    setActiveTab("liveTETData");
  };

  useEffect(() => {
    resetState();
    if (countryOptions.length === 0) {
      getCountriesList();
    }
    if (languageOptions.length === 0) {
      getLanguageList();
    }
    if (userTypeOptions.length === 0) {
      getUserTypeList();
    }
  }, []);

  const handleUserTypeChange = useCallback(() => {
    let fieldsValue = fields;
    fieldsValue.product.value = "";
    fieldsValue.language.value = "";
    setFields({ ...fieldsValue });
    setShowRule(false);
    setActiveTab("liveTETData");
  }, [fields]);

  const handleLanguageChange = useCallback(() => {
    let fieldsValue = fields;
    fieldsValue.product.value = "";
    setFields({ ...fieldsValue });
    setShowRule(false);
    setActiveTab("liveTETData");
  }, [fields]);

  const handleCountryChange = useCallback(
    (event) => {
      let fieldsValue = fields;
      fieldsValue.product.value = "";
      fieldsValue.userType.value = "";
      fieldsValue.language.value = "";
      const affiliate = countryList.find(
        (item) => item.country === event
      ).affiliate;
      const queryParams = {
        affiliate: affiliate,
      };

      api_v2.fetchTETProducts(queryParams, (res) => {
        const TETProductOptions = [];
        res.forEach((product) => {
          TETProductOptions.push({
            value: product.productCode,
            label: product.name,
          });
        });
        setProductOptions(TETProductOptions);
      });
      setFields({ ...fieldsValue });
      setShowRule(false);
      setActiveTab("liveTETData");
    },
    [countryList]
  );

  //language api
  const getLanguageList = useCallback(() => {
    const languageOptions = [];
    api_v2.fetchTETLanguage((JsonKeys) => {
      JsonKeys.forEach((languageList) => {
        languageOptions.push({
          value: languageList.code,
          label: languageList.language,
        });
      });
      setLanguageOptions(languageOptions);
    });
  }, []);

  //user type api
  const getUserTypeList = useCallback(() => {
    const userTypeOptions = [];
    api_v2.fetchTETRulesUserType((userTypes) => {
      userTypes.forEach((userType) => {
        userTypeOptions.push({
          value: userType,
          label: userType,
        });
      });
      setUserTypeOptions(userTypeOptions);
    });
  }, []);

  const handleSearchRule = useCallback(() => {
    const payload = {
      countryName: fields.country.value,
      userType: fields.userType.value,
      language: fields.language.value,
      productCode: fields.product.value,
    };
    api_v2.fetchTETRule(payload, (res) => {
      if (res.live === null && res.draft === null) {
        setShowAdminConfirmationModal(true);
        setActiveTab("draftTETData");
      } else if (res.live !== null && res.draft === null) {
        setShowRule(true);
      } else if (res.live === null && res.draft !== null) {
        setActiveTab("draftTETData");
        setShowRule(true);
      } else if (res.live !== null && res.draft !== null) {
        setShowRule(true);
      } else {
        showNotification(
          "Error",
          "Something went wrong, Please try again later",
          "error"
        );
      }
    });
  }, [fields]);

  const showNotification = (title, message, status) => {
    props.notify({
      title,
      message,
      status,
      position: "tr",
      dismissible: true,
      dismissAfter: 3000,
    });
  };

  const handleCreateNewTETRule = useCallback(() => {
    const payload = {
      countryName: fields.country.value,
      userType: fields.userType.value,
      language: fields.language.value,
      productCode: fields.product.value,
      rules: {},
    };
    api_v2.createNewDraftTETRule(payload, (res) => {
      if (res.ok && res.status === 200) {
        showNotification("Success", "Created Successfully", "success");
        setShowAdminConfirmationModal(false);
        handleSearchRule();
      } else {
        showNotification(
          "Error",
          "Something went wrong, Please try again later",
          "error"
        );
      }
    });
  }, []);

  const handleCloseModal = () => {
    resetState();
    setShowAdminConfirmationModal(false);
  };

  return (
    <div id="manage-admin-list" className="v2_container">
      <div className="row">
        <AdminConfirmationModal
          isModalOpen={showAdminConfirmationModal}
          toggleYes={handleCreateNewTETRule}
          toggleCancel={handleCloseModal}
          bodyContent={
            "This product not exist in our system. Are you sure do you want to configure the rule?"
          }
        />
        <AdminNavigation className="col-xl-2 col-lg-3 col-md-4 col-6" />
        <div className="col-xl-10 col-lg-9 col-md-8 col-6 p-l-15">
          <div className="row manage-admin-list-header">
            <div className="col-12 col-xl-12">
              <h3 className="mb-3 header-primary">
                Manage TET Rules Configuration
              </h3>
            </div>
          </div>
          <div>
            <div className="row">
              <div className=" col-md-4">
                <Select
                  searchable
                  clearable={false}
                  options={countryOptions}
                  field={fields.country}
                  validate={(e) => validate(e, fields.country)}
                  onChange={(e) => handleCountryChange(e)}
                />
              </div>
              <div className="col-md-4">
                <Select
                  searchable
                  clearable={false}
                  options={userTypeOptions}
                  field={fields.userType}
                  validate={(e) => validate(e, fields.userType)}
                  onChange={handleUserTypeChange}
                />
              </div>
              <div className=" col-md-4">
                <Select
                  searchable
                  clearable={false}
                  options={languageOptions}
                  field={fields.language}
                  validate={(e) => validate(e, fields.language)}
                  onChange={handleLanguageChange}
                />
              </div>
            </div>
            <div className="row">
              <div className=" col-md-4" style={{ alignContent: "end" }}>
                <Select
                  searchable
                  clearable={false}
                  options={productOptions}
                  field={fields.product}
                  validate={(e) => validate(e, fields.product)}
                  onChange={() => setShowRule(false)}
                />
              </div>
              <div className=" col-md-2">
                <button
                  className="btn btn-lg btn-info btn-rounded save_button"
                  onClick={handleSearchRule}
                  disabled={
                    fields.country.value === "" ||
                    fields.product.value === "" ||
                    fields.userType.value === "" ||
                    fields.language.value === ""
                  }
                >
                  Search
                </button>
              </div>
            </div>
            {showRule && (
              <div>
                <div
                  className="row"
                  style={{ marginTop: "15px", marginLeft: "1px !important" }}
                >
                  <div
                    className={`col-4 col-xl-4 col-sm-6 tetLiveTab ${
                      activeTab === "liveTETData" ? "activeTab" : ""
                    }`}
                    onClick={() => handleTabClick("liveTETData")}
                  >
                    TET Live Data
                  </div>

                  {/* TET Draft Data Tab */}
                  <div
                    className={`col-4 col-xl-4 col-sm-6 tetLiveTab ${
                      activeTab === "draftTETData" ? "activeTab" : ""
                    }`}
                    onClick={() => handleTabClick("draftTETData")}
                  >
                    TET Draft Data
                  </div>
                </div>
                {activeTab === "liveTETData" && (
                  <TETRulesLive
                    {...props}
                    TETFields={fields}
                    setActiveTab={setActiveTab}
                    showNotification={showNotification}
                  />
                )}
                {activeTab === "draftTETData" && (
                  <TETRulesDraft
                    {...props}
                    setActiveTab={setActiveTab}
                    TETFields={fields}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    referenceData: state.referenceData
  };
}

export default connect(mapStateToProps, { notify })(TETRulesConfiguration);



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/TET/V2TETRulesConfiguration.js